import { cn, Heading, Text, VStack } from '@vidahealth/vida-ui';
import { type ComponentProps } from 'react';

type VStackProps = ComponentProps<typeof VStack>;

type ScreenHeadingProps = {
  title?: string;
  subtitle?: string;
  space?: VStackProps['space'];
  center?: boolean;
};

export function ScreenHeading({
  title,
  subtitle,
  space = 'md',
  center = false,
}: ScreenHeadingProps) {
  if (!title && !subtitle) return null;

  return (
    <VStack space={space}>
      {title ? (
        <Heading
          size='xl'
          className={cn(
            'font-heading-semibold text-primary-800 dark:text-primary-0',
            center && 'text-center'
          )}
        >
          {title}
        </Heading>
      ) : null}
      {subtitle ? (
        <Text size='md' className={cn('text-typography-800', center && 'text-center')}>
          {subtitle}
        </Text>
      ) : null}
    </VStack>
  );
}
